export const ABSENCE_TYPES = {
	// Illness and Accidents Group
	ILLNESS: 'illness',
	ILLNESS_RELATIVES: 'illnessRelatives',
	WORK_ACCIDENT: 'workAccident',
	NONWORK_ACCIDENT: 'nonworkAccident',
	MATERNITY: 'maternity',
	PATERNITY: 'paternity',
	PAID_ABSENCE: 'paidAbsence',

	// Preference Group
	OFFTIME: 'offtime',
	REDUCE: 'reduce',
	WORK_PREFERENCE: 'workPreference',
	WORK_AGREEMENT: 'workAgreement',

	// Other Group
	VACATION: 'vacation',
	SERVICE: 'service',
	JUSTIFIED_ABSENCE: 'justifiedAbsence',
	UNPAID_VACATION: 'unpaidVacation',
	EDUCATION: 'education',
	WORK: 'work',
	SENIORITY_GIFT: 'seniorityGift',
};

/**
 * Group names constants
 */
export const ABSENCE_GROUPS = {
	ILLNESS_AND_ACCIDENTS: 'illnessAndAccidents',
	PREFERENCE: 'preference',
	OTHER: 'other',
};

/**
 * Status types constants
 */
export const ABSENCE_STATUS = {
	APPROVED: 'approved',
	PENDING: 'pending',
};

/**
 * Absence type groups configuration
 * Maps groups to their respective absence types
 */
export const ABSENCE_TYPE_GROUPS = {
	[ABSENCE_GROUPS.ILLNESS_AND_ACCIDENTS]: [
		ABSENCE_TYPES.ILLNESS,
		ABSENCE_TYPES.ILLNESS_RELATIVES,
		ABSENCE_TYPES.WORK_ACCIDENT,
		ABSENCE_TYPES.NONWORK_ACCIDENT,
		ABSENCE_TYPES.MATERNITY,
		ABSENCE_TYPES.PATERNITY,
		ABSENCE_TYPES.PAID_ABSENCE,
	],
	[ABSENCE_GROUPS.PREFERENCE]: [ABSENCE_TYPES.OFFTIME, ABSENCE_TYPES.REDUCE, ABSENCE_TYPES.WORK_PREFERENCE, ABSENCE_TYPES.WORK_AGREEMENT],
	[ABSENCE_GROUPS.OTHER]: [
		ABSENCE_TYPES.VACATION,
		ABSENCE_TYPES.SERVICE,
		ABSENCE_TYPES.JUSTIFIED_ABSENCE,
		ABSENCE_TYPES.UNPAID_VACATION,
		ABSENCE_TYPES.EDUCATION,
		ABSENCE_TYPES.WORK,
		ABSENCE_TYPES.SENIORITY_GIFT,
	],
};
